import { Injectable } from '@angular/core'
import { MbCheckoutBillingFormAdapter } from './mb-checkout-billing-form.adapter'
import { MbBillingInformation } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutBillingFormConnector {

  constructor (protected adapter: MbCheckoutBillingFormAdapter) {
  }

  get (cartID: string, userID: string) {
    return this.adapter.load(cartID, userID)
  }

  post (form: MbBillingInformation, cartID: string, userID: string) {
    return this.adapter.post(form, cartID, userID)
  }
}
